<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition"
       [ngClass]="{'-is-open': clubOverviewService.listOfModals.editClubDataModal}">
  <div class="esf-main-sidebar__content">
    <h3><span i18n='Club data edit modal title@@clubComponent.workspaceTitle.editClubData'>Edit club data</span></h3>
    <form [formGroup]="clubForm" (ngSubmit)="updateClub()" id="editClubDataForm">
      <div app-form-field-text-generic
           [control]="clubForm.get('name')"
           [placeholder]="flTranslations.i18nName"
           [label]="flTranslations.i18nName">
      </div>
      <div class="esf-form-group">
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [control]="clubForm.get('id')"
             [placeholder]="flTranslations.i18nClubNumber"
             [label]="flTranslations.i18nClubNumber">
        </div>
        <div app-form-field-select
             class="esf-form-item--1-2"
             [label]="flTranslations.i18nStatus"
             [control]="clubForm.get('status')"
             [array]="selectedClub.statuses">
        </div>
      </div>
      <div app-form-field-select
           [label]="flTranslations.i18nCurrency"
           [control]="clubForm.get('preferredCurrency')"
           [array]="currencyDropdown">
      </div>
    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open">
  <app-submit-row-buttons [form]="'editClubDataForm'"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="clubOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space esf-js-workingSpaceToggle -has-transition"
     [ngClass]="{'-is-open': clubOverviewService.listOfModals.editClubDataModal }" (click)="clubOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
